// extracted by css-extract-rspack-plugin
module.exports =  {"root":"Checkout__root___pzrvX"};